import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_HERO_PROMOTE_REQUEST =
  'HeroPromote/FETCH_HERO_PROMOTE_REQUEST'
const FETCH_HERO_PROMOTE_SUCCESS =
  'HeroPromote/FETCH_HERO_PROMOTE_SUCCESS'
const FETCH_HERO_PROMOTE_FAILURE =
  'HeroPromote/FETCH_HERO_PROMOTE_FAILURE'

const FETCH_HERO_PROMOTE_BY_ID_REQUEST =
  'HeroPromote/FETCH_HERO_PROMOTE_BY_ID_REQUEST'
const FETCH_HERO_PROMOTE_BY_ID_SUCCESS =
  'HeroPromote/FETCH_HERO_PROMOTE_BY_ID_SUCCESS'
const FETCH_HERO_PROMOTE_BY_ID_FAILURE =
  'HeroPromote/FETCH_HERO_PROMOTE_BY_ID_FAILURE'

const DELETE_HERO_PROMOTE_REQUEST =
  'HeroPromote/DELETE_HERO_PROMOTE_REQUEST'
const DELETE_HERO_PROMOTE_SUCCESS =
  'HeroPromote/DELETE_HERO_PROMOTE_SUCCESS'
const DELETE_HERO_PROMOTE_FAILURE =
  'HeroPromote/DELETE_HERO_PROMOTE_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroPromoteList: [],
  heroPromoteObj: {}
}

// Default Reducer
const heroPromote = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HERO_PROMOTE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_PROMOTE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroPromoteList: action.payload
      }
    case FETCH_HERO_PROMOTE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_HERO_PROMOTE_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERO_PROMOTE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroPromoteObj: action.payload
      }
    case FETCH_HERO_PROMOTE_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_HERO_PROMOTE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_HERO_PROMOTE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_HERO_PROMOTE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default heroPromote

// Action Creators
export const fetchHeroPromoteList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_PROMOTE_REQUEST
      })

      const data = await API.get(EndPoints.HEROPROMOTE+ `/getAllPromote`)
      dispatch({
        type: FETCH_HERO_PROMOTE_SUCCESS,
        payload: data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_PROMOTE_FAILURE
      })
    }
  }
}

export const deleteHeroPromote = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_HERO_PROMOTE_REQUEST
      })
      await API.delete(EndPoints.HEROPROMOTE + `/${id}`)
      dispatch({
        type: DELETE_HERO_PROMOTE_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_HERO_PROMOTE_FAILURE
      })
    }
  }
}

export const fetchHeroPromoteDetail = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERO_PROMOTE_BY_ID_REQUEST
      })

      const { data } = await API.get(
        EndPoints.HEROPROMOTE + `/getAnswer/${id}`
      )
      const heroOfferAdminList = data
      const interestedHero = heroOfferAdminList.filter(
        (hero) => hero.suggestPrice !== 0
      )
      const notInterestedHero = heroOfferAdminList.filter(
        (hero) => hero.suggestPrice === 0
      )
      const response = {
        interestedHero,
        notInterestedHero
      }
      dispatch({
        type: FETCH_HERO_PROMOTE_BY_ID_SUCCESS,
        payload: response
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERO_PROMOTE_BY_ID_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/heroPromote.js